import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      meta: { title: '首页' },
      component: () => import('../views/home/index')
    },
    {
      path:"/searchList",
      name:'SearchList',
      meta:{title:'搜索列表'},
      component:()=> import('../views/home/searchList')
    },
    {
      path: '/courseList',
      name: 'CourseList',
      meta: { title: '课程分类' },
      component: () => import('../views/course/courseList')
    },
    {
      path: '/videoDetail',
      name: 'VideoDetail',
      meta: { title: '视频课程详情' },
      component: () => import('../views/course/videoDetail')
    },
    {
      path: '/lookVideo',
      name: 'LookVideo',
      meta: { title: '观看视频课程' },
      component: () => import('../views/course/lookVideo')
    },
    {
      path: '/imageText',
      name: 'ImageText',
      meta: { title: '图文详情' },
      component: () => import('../views/course/imageText')
    },
    {
      path: '/newsList',
      name: 'NewsList',
      meta: { title: '资讯频道' },
      component: () => import('../views/news/newsList')
    },
    {
      path: '/newsDetail',
      name: 'NewsDetail',
      meta: { title: '资讯详情' },
      component: () => import('../views/news/newsDetail')
    },
    {
      path: '/resourceList',
      name: 'ResourceList',
      meta: { title: '资源下载' },
      component: () => import('../views/resource/resourceList')
    },
    {
      path: '/resourceDetail',
      name: 'ResourceDetail',
      meta: { title: '资源详情' },
      component: () => import('../views/resource/resourceDetail')
    },
    {
      path: '/about',
      name: 'About',
      meta: { title: '关于我们' },
      component: () => import('../views/other/about')
    },
    {
      path: '/help',
      name: 'Help',
      meta: { title: '帮助中心' },
      component: () => import('../views/other/help')
    },
    {
      path: '/my',
      name: 'My',
      meta: { title: '我的主页' },
      component: () => import('../views/user/my'),
      redirect: { name: 'PlayHistory' },
      children: [
        {
          path: '/playHistory',
          name: 'PlayHistory',
          meta: { title: '播放历史' },
          component: () => import('../views/user/playHistory'),
        },
        {
          path: '/collect',
          name: 'Collect',
          meta: { title: '我的收藏' },
          component: () => import('../views/user/collect'),
        },
        {
          path: '/theChart',
          name: 'TheChart',
          meta: { title: '数据统计' },
          component: () => import('../views/user/theChart'),
        },
        {
          path: '/message',
          name: 'Message',
          meta: { title: '我的消息' },
          component: () => import('../views/user/message'),
        },
        {
          path: '/userInfo',
          name: 'UserInfo',
          meta: { title: '个人信息' },
          component: () => import('../views/user/userInfo'),
        },
        {
          path: '/editPass',
          name: 'EditPass',
          meta: { title: '账户安全' },
          component: () => import('../views/user/editPass'),
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      meta: { title: '登录' },
      component: () => import('../views/login/login')
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition && to.meta.keepAlive) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js